import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export var setCompliantLocalStorageItem = createAction("".concat(reduxKey, "/SET_ITEM"), function (payload) { return payload; });
export var removeCompliantLocalStorageItem = createAction("".concat(reduxKey, "/REMOVE_ITEM"), function (key) { return ({ key: key }); });
//# sourceMappingURL=actions.js.map